
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[author]/map",
      function () {
        return require("private-next-pages/[author]/map.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[author]/map"])
      });
    }
  